<template>
  <div class="app-container">
    <div class="app-content">
      <el-card class="auth-container" shadow="never">
        <template #header>
          <el-form size="small" inline @submit.native.prevent>
            <el-form-item label="设备类型">
              <el-select v-model="queryParams.gtype" placeholder="" clearable>
                <el-option
                  v-for="item in devtypes"
                  :key="item.key"
                  :value="item.value"
                  :label="item.key"
                />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('text.xlh')">
              <el-input
                v-model="queryParams.gatewaysn"
                clearable
                :placeholder="$t('placeholder.srxlh')"
              />
            </el-form-item>
            <el-form-item :label="$t('text.xlh')">
              <!-- 查询 -->
              <el-button
                type="primary"
                icon="el-icon-search"
                :loading="loading"
                @click="handleQuery"
              >{{ $t("button.cx") }}</el-button>

              <!-- 授权 -->
              <el-button
                type="primary"
                icon="el-icon-s-check"
                @click="handleAuth"
              >{{ $t("button.sq") }}</el-button>

              <!-- 取消授权 -->
              <el-button
                type="warning"
                icon="el-icon-close"
                @click="handleAuthCancel"
              >{{ $t("button.qxsq") }}</el-button>
            </el-form-item>

          </el-form>
        </template>

        <template #default>
          <el-table
            v-loading="loading"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.7)"
            height="calc(100% - 50px)"
            :data="tableData"
            @selection-change="handleSelectionChange"
          >
            <el-table-column :label="$t('text.xh')" type="index" width="55" align="center" />
            <el-table-column type="selection" width="60" align="center" />
            <el-table-column label="SIM" prop="sim" width="220" :formatter="$elFormatter" />
            <el-table-column :label="$t('text.sbxlh')" prop="gatewaysn" />
            <el-table-column :label="$t('text.sbbm')" prop="alias" :formatter="$elFormatter" />
            <el-table-column label="设备类型" width="150" :formatter="devDescript" />
            <el-table-column :label="$t('text.fxs')" prop="distributor" :formatter="$elFormatter" />
            <el-table-column :label="$t('text.azs')" prop="installer" :formatter="$elFormatter" />
            <el-table-column :label="$t('text.zdyh')" prop="terminal" :formatter="$elFormatter" />
            <el-table-column label="所属电站" prop="orgname" :formatter="$elFormatter" />
            <el-table-column :label="$t('text.cz')" width="100">
              <template v-slot="scope">
                <el-button
                  type="text"
                  class="danger"
                  size="small"
                  icon="el-icon-delete"
                  @click="handleDelete(scope.row)"
                >{{ $t("button.sc") }}</el-button>
              </template>
            </el-table-column>
          </el-table>

          <el-pagination
            size="small"
            background
            :total="page.total"
            :current-page.sync="page.pageNum"
            :page-size.sync="page.pageSize"
            @current-change="getTableData"
          />
        </template>
      </el-card>

      <!-- 授权弹出框 -->
      <el-dialog
        width="30%"
        append-to-body
        :title="$t('button.sq')"
        :visible="auth.visible"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        @close="auth.visible = false"
        @opened="handleOpenAuthDialog"
      >
        <el-form class="text-center">
          <el-form-item :label="$t('text.fxs')">
            <el-select v-model="auth.distributorid" filterable clearable @change="handleDistributorChange">
              <el-option v-for="item in auth.distributorOptions" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('text.azs')">
            <el-select :key="auth.installeridSelectELementKey" v-model="auth.installerid" filterable clearable>
              <template v-if="auth.installerOptions[auth.distributorid]">
                <el-option v-for="item in auth.installerOptions[auth.distributorid]" :key="item.value" :label="item.label" :value="item.value" />
              </template>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleAuthConfirm">{{
              $t("button.qd")
            }}</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>

      <!-- 取消授权弹出框 -->
      <el-dialog
        width="30%"
        append-to-body
        :title="$t('button.qxsq')"
        :visible.sync="cancelVisible"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
      >
        <el-form class="text-center">
          <el-form-item :label="$t('text.qxz')">
            <el-select v-model="unAuthSelectType" clearable>
              <el-option :label="$t('text.fxs')" value="2" />
              <el-option :label="$t('text.azs')" value="3" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleAuthCancelBtn">{{
              $t("button.qd")
            }}</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { QueryGateways, Auth, RemoveAuth, DeleteGateways, GetDistributorsAndInstallers } from '@apis/Device'
export default {
  data () {
    return {
      /** 查询参数 */
      queryParams: {
        /** 设备类型 */
        gtype: "",
        /** 设备序列号 */
        gatewaysn: "",
      },
      /** 设备类型 */
      devtypes: [
        { key: "组串", value: "0" },
        { key: "储能", value: "1" },
        { key: "气象", value: "2" },
        { key: "电表", value: "3" },
        { key: "摄像头", value: "4" },
        { key: "开关", value: "5" },
      ],
      /** 加载中 */
      loading: false,
      /** 表格数据 */
      tableData: [],
      /** 分页 */
      page: {
        /** 总条数 */
        total: 0,
        /** 当前页码 */
        pageNum: 1,
        /** 每页条数 */
        pageSize: 10,
      },
      /** 选中项 */
      multipleSelection: [],

      /** 授权参数 */
      auth: {
        /** 弹出框是否显示 */
        visible: false,
        /** 分销商ID */
        distributorid: "",
        /** 安装商ID */
        installerid: "",

        /** 是否初始化分销商选项 */
        isInitDistributorOptions: false,
        /** 分销商选项 */
        distributorOptions: [],
        /** 安装商选项 */
        installerOptions: {},

        /** 安装商选择框元素key */
        installeridSelectELementKey: Math.random()
      },

      /** 取消授权弹出框 */
      cancelVisible: false,
      /** 取消授权类型 */
      unAuthSelectType: "",
    }
  },
  computed: {
    /** 设备类型描述 */
    devDescript () {
      return (row, column, cellValue, index) => {
        let result = ""
        const device = this.devtypes.find((item) => item.value === row.gtype)
        if (device) {
          result = device.key
        }
        return result
      }
    },
  },
  created () {
    this.getTableData()
  },
  methods: {
    /** 多选 */
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    /** 查询 */
    handleQuery () {
      this.page.pageNum = 1
      this.getTableData()
    },
    /** 获取表格数据 */
    getTableData () {
      this.loading = true
      QueryGateways({
        page: this.page.pageNum,
        perPage: this.page.pageSize,
        orderBy: "",
        whereCondition: JSON.stringify(this.queryParams),
      })
        .then((res) => {
          this.tableData = res.data.queryResults
          this.page.total = res.data.totalCount
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    /** 授权按钮 */
    handleAuth () {
      if (this.multipleSelection.length === 0) {
        this.$message({
          type: "warning",
          message: this.$t("notice.zsyg"),
          duration: 1 * 1000,
        })
      } else {
        this.ids = this.multipleSelection.map((o) => o.id)
        this.auth.visible = true
      }
    },
    /** 打开授权弹出框 */
    handleOpenAuthDialog () {
      if (!this.auth.isInitDistributorOptions) {
        GetDistributorsAndInstallers({ id: '0' }).then((res) => {
          this.auth.distributorOptions = res.data.map((item) => {
            return {
              label: item.key,
              value: item.value,
            }
          })
          this.auth.isInitDistributorOptions = true
        }).catch(() => {})
      }
    },
    /** 分销商改变时，获取安装商选项 */
    handleDistributorChange (val) {
      this.auth.installerid = ""
      if (val && !this.auth.installerOptions[val]) {
        GetDistributorsAndInstallers({ id: val }).then((res) => {
          if (res.data && res.data.length > 0) {
            this.auth.installerOptions[val] = res.data.map((item) => {
              return {
                label: item.key,
                value: item.value,
              }
            })
          } else {
            this.auth.installerOptions[val] = []
          }
          this.auth.installeridSelectELementKey = Math.random()
        }).catch(() => {})
      } else {
        this.auth.installeridSelectELementKey = Math.random()
      }
    },
    /** 确认授权 */
    handleAuthConfirm () {
      this.$confirm(this.$t("notice.sq"), this.$t("notice.title"), {
        confirmButtonText: this.$t("button.qr"),
        cancelButtonText: this.$t("button.qx"),
        type: "warning",
      })
        .then(() => {
          Auth({
            gatewayids: this.ids,
            distributorid: this.auth.distributorid,
            installerid: this.auth.installerid,
          }).then(() => {
            this.auth.visible = false
            this.getTableData()
          }).then(() => {
            this.$message({
              type: "success",
              message: this.$t("notice.sqcg"),
              duration: 1 * 1000,
            })
          })
        })
        .catch(() => {})
    },
    /** 取消授权 */
    handleAuthCancel () {
      const ids = this.multipleSelection.map((o) => {
        return o.id
      })
      if (ids.length) {
        this.cancelVisible = true
        this.ids = ids
      } else {
        this.$message({
          type: "warning",
          message: this.$t("notice.zsyg"),
          duration: 1 * 1000,
        })
      }
    },
    /** 确认取消授权 */
    handleAuthCancelBtn () {
      this.$confirm(this.$t("notice.qxsq"), this.$t("notice.title"), {
        confirmButtonText: this.$t("button.qr"),
        cancelButtonText: this.$t("button.qx"),
        type: "warning",
      })
        .then(() => {
          RemoveAuth({
            ids: this.ids,
            tag: this.unAuthSelectType,
          }).then(() => {
            this.$message({
              type: "success",
              message: this.$t("notice.qxsqcg"),
              duration: 1 * 1000,
            })
            this.cancelVisible = false
            this.getTableData()
          })
        })
        .catch(() => {})
    },
    /** 删除设备 */
    handleDelete (row) {
      this.$confirm(this.$t("notice.scsb"), this.$t("notice.title"), {
        confirmButtonText: this.$t("button.qr"),
        cancelButtonText: this.$t("button.qx"),
        type: "warning",
      })
        .then(() => {
          return DeleteGateways({ id: row.id })
        })
        .then(() => {
          this.$msgSuccess(this.$t("notice.sccg"))
          this.getTableData()
        })
        .catch(() => {})
    },
  },
}
</script>
<style scoped>
.auth-container{
  width: 100%;
  height: 100%;
  padding: 0;
  box-sizing: border-box;
  background-color: #1d3666;
  border-color: #1d3666;
}

.auth-container >>> .el-card__header{
  width: 100%;
  height: 50px;
  padding: 0 20px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
}
.auth-container >>> .el-card__header .el-form-item{
  margin-bottom: 0;
}

.auth-container >>> .el-card__body{
  width: 100%;
  height: calc(100% - 50px);
  padding: 0 20px 10px;
  box-sizing: border-box;
}
.auth-container >>> .el-card__body .el-table{
  width: 100%;
  box-sizing: border-box;
}
.auth-container >>> .el-card__body .el-pagination{
  width: 100%;
  height: 50px;
  padding: 0;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

</style>
